import { Settings, DateTime, Interval } from 'luxon';

Settings.throwOnInvalid = true;

export function setDefaultZone() {
  Settings.defaultZone = 'utc';
}

export function plusXDaysString(date: string, amount = 1): string {
  return DateTime.fromISO(date)
    .setZone('utc')
    .startOf('day')
    .plus({ days: amount })
    .toISO();
}

export function plusXDays(date: string, amount = 1): DateTime {
  return DateTime.fromISO(date)
    .setZone('utc')
    .startOf('day')
    .plus({ days: amount });
}

export function daysBetweenDates(startDate: string, endDate: string): number {
  const start = DateTime.fromISO(startDate);
  const end = DateTime.fromISO(endDate);

  return Math.round(end.diff(start, ['days']).days);
}

export function relativeDate(date: string): string {
  return (
    DateTime.fromISO(date)
      .setZone('utc')
      .toRelative({
        unit: ['years', 'months', 'days', 'hours', 'minutes'],
      }) || '-'
  );
}

export function rangeOfDates(startDate: string, endDate: string) {
  const start = DateTime.fromISO(startDate);
  const end = DateTime.fromISO(endDate);

  return Interval.fromDateTimes(start, end)
    .splitBy({ days: 1 })
    .map((d) => d.start.toISO());
}

export function isBetweenDates(
  date: string,
  startDate: string,
  endDate: string,
): boolean {
  const target = DateTime.fromISO(date);
  const start = DateTime.fromISO(startDate).startOf('day');
  const end = DateTime.fromISO(endDate).endOf('day');

  // Validate that the interval is valid (end >= start)
  if (end < start) {
    return false;
  }

  return Interval.fromDateTimes(start, end).contains(target);
}
